import { formReveal } from '../utilities/_helpers.js';

document.addEventListener('DOMContentLoaded', () => {
  formReveal([{ block: '.hero', contentSelector: '.hero-content' }]);
});
